/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".phone-container[_ngcontent-%COMP%]{position:relative;margin:1rem 0 2rem}.phone-container[_ngcontent-%COMP%]   .input-wrap[_ngcontent-%COMP%]{position:relative;max-width:420px}.phone-container[_ngcontent-%COMP%]   .input-prefix[_ngcontent-%COMP%]{position:absolute;left:10px;top:49%;-ms-transform:translateY(-50%);transform:translateY(-50%)}.phone-container[_ngcontent-%COMP%]   .input-text[_ngcontent-%COMP%]{padding-left:48px}.form-field[_ngcontent-%COMP%]{max-width:460px}"];
export { styles as styles };
